import axios from 'axios'
import VueCookies from 'vue-cookies'

// axios.defaults.withCredentials = true;
var token = VueCookies.get("supaccess-token");
var expiry = VueCookies.get("supexpiry");
var client = VueCookies.get("supclient");
var uid = VueCookies.get("supuid");
const httpClient = axios.create({
    // baseURL: "https://test.domain:3001",
    // baseURL: "https://supportteam.webmoney.com",
    baseURL: process.env.VUE_APP_BASE_URL,
    headers: {
        "Content-Type": "application/json",
        "Access-Token": token,
        "Expiry": expiry,
        "Client": client,
        "Token-Type": "Bearer",
        "Uid": uid
    }
});

export default httpClient;